export const locales = [
  'en',
  'ar-AE',
  'bg-BG',
  'bn',
  'cs-CZ',
  'da-DK',
  'de',
  'en-AU',
  'el-GR',
  'en-GB',
  'en-IE',
  'es',
  'es-419',
  'es-ES',
  'fi-FI',
  'fr-CA',
  'fr-FR',
  'gu',
  'he-IL',
  'hi-IN',
  'hu-HU',
  'id-ID',
  'it',
  'ja',
  'km-KH',
  'ko',
  'mr',
  'ms-MY',
  'my-MM',
  'nl-NL',
  'pl-PL',
  'pt-BR',
  'ro-RO',
  'ru',
  'sk-SK',
  'sl-SI',
  'sr-RS',
  'sv-SE',
  'ta',
  'te',
  'th-TH',
  'tl-PH',
  'tr-TR',
  'uk-UA',
  'vi-VN',
  'zh-CN',
  'zh-TW',
  'zh-HK',
];
